import React from 'react';
import { IconButton, Tooltip, TableCell } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const ActionsButtons = ({
  handleDetailsPage,
  seletedRow,
  row,
  setSelectedRow,
  openByProps,
  setOpenByProps,
  detailRequest,
}) => {
  const handleChangeArrow = () => {
    handleDetailsPage();
    detailRequest(row.device_id); // passa device_id para o pai buscar histórico
    setSelectedRow(row);
    setOpenByProps(
      seletedRow?.device_id === row.device_id ? !openByProps : true
    );
  };

  return (
    <TableCell>
      <Tooltip title="Expandir">
        <IconButton
          aria-label="expand row"
          size="small"
          onClick={handleChangeArrow}
        >
          {openByProps &&
          seletedRow &&
          seletedRow.device_id === row.device_id ? (
            <KeyboardArrowUpIcon />
          ) : (
            <KeyboardArrowDownIcon />
          )}
        </IconButton>
      </Tooltip>
    </TableCell>
  );
};

export default ActionsButtons;
